import React, { Component } from "react";
import { connect } from 'react-redux';
import { Row, Col, Form} from "react-bootstrap";
import moment from 'moment'

import {updateSearchField} from '../../actions'
import './wildcardSearch.scss'
import {Countries } from '../../config'

class WildcardSearch extends Component {

  onChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });

    const { target } = event;
    const { name, value } = target;
    
    this.props.updateSearchField({name, value}, true)
  }

  render() {
    const now = new Date();   
    
    const minDate = moment(`${(now.getFullYear() - 90)}-01-01`).format( 'YYYY-MM-DD')
    const maxDate = moment(`${now.getFullYear()}-${(now.getMonth()+1)}-${now.getDate()}`).format('YYYY-MM-DD') 
    const role = window.localStorage.getItem('role')
    return (
        <Row className="wildcardSearch">
            <Col md={12} >
                <h4>Wildcard Search</h4>
                {role==='SRO Officer'?<Form.Group>
                    <Form.Row>
                        <Form.Label column="sm" lg={3}>
                            CRB No
                        </Form.Label>
                        <Col>
                            <Form.Control size="sm" type="text" name='File_No' placeholder="Enter CRB number"  onChange={this.onChange} />
                        </Col>
                    </Form.Row>
                </Form.Group>:
                <Form.Group>
                    <Form.Row>
                        <Form.Label column="sm" lg={3}>
                            CRB No
                        </Form.Label>
                        <Col>
                            <Form.Control size="sm" type="text" name='File_No' placeholder="Enter CRO number"  onChange={this.onChange} />
                        </Col>
                    </Form.Row>
                </Form.Group>
                }
                <Form.Group>
                    <Form.Row>
                        <Form.Label column="sm" lg={3}>
                            Name
                        </Form.Label>
                        <Col>
                            <Form.Control size="sm" type="text" name='Name1' placeholder="Enter name" pattern="[^'\x22]+"  onChange={this.onChange} />
                        </Col>
                    </Form.Row>
                </Form.Group>
                <Form.Group>
                    <Form.Row>
                        <Form.Label column="sm" lg={3}>
                            AFIS
                        </Form.Label>
                        <Col>
                            <Form.Control size="sm" type="text" name='Name2' placeholder="Enter AFIS No" pattern="[^'\x22]+"  onChange={this.onChange} />
                        </Col>
                    </Form.Row>
                </Form.Group>
                {/* <Form.Group>
                    <Form.Row>
                        <Form.Label column="sm" lg={3}>
                            D.O.B
                        </Form.Label>
                        <Col>
                            <Form.Control size="sm" type="date" name='DOB' min={minDate} max={maxDate} placeholder="Enter Date of birth"  onChange={this.onChange} />
                        </Col>
                    </Form.Row>
                </Form.Group> */}
                <Form.Group>
                    <Form.Row>
                        <Form.Label column="sm" lg={3}>
                            Station
                        </Form.Label>
                        <Col>
                            <Form.Control size="sm" type="text" name='POB' placeholder="Enter station"  onChange={this.onChange} />
                        </Col>
                    </Form.Row>
                </Form.Group>
                <Form.Group>
                    <Form.Row>
                        <Form.Label column="sm" lg={3}>
                            Nationality
                        </Form.Label>
                        <Col>
                            <Form.Control as="select" size="sm" name='Nationality' custom onChange={this.onChange} >
                                <option>Select Nationality</option>
                                {Countries.length > 0 ? Countries.map(country => (
                                    <option value={country.name} key={country.code}>{country.name}</option> 
                                )): <option value='uganda'>Uganda</option> }
                                
                            </Form.Control>
                        </Col>
                    </Form.Row>
                </Form.Group>
                {/* <Form.Group>
                    <Form.Row>
                        <Form.Label column="sm" lg={3}>
                            Name
                        </Form.Label>
                        <Col>
                            <Form.Control size="sm" type="text" name='Company' placeholder=""  onChange={this.onChange}  />
                        </Col>
                    </Form.Row>
                </Form.Group> */}
            </Col>
        </Row>
    );
  }
}

const mapStateToProps = ({  records }) => {
	return {
    records
	};
};

export default connect(
	mapStateToProps,
	{ updateSearchField }
)(WildcardSearch);